import { Gavel } from 'lucide-react';

import { humanizeLabel } from '@/nucleo/displayLabels';
import { formatarDinheiro } from '@/nucleo/dinheiro';
import { EmptyState } from '@/ui/EmptyState';
import { Spinner } from '@/ui/Spinner';
import { StatusBadge, type StatusVariant } from '@/ui/StatusBadge';
import { Card, CardContent } from '@/ui/base/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/ui/base/table';

import { useMultasDoCredenciado, type MultaDoCredenciado } from './detalheDados';

interface AbaMultasProps {
  credenciadoId: string;
}

const SELO_DA_MULTA: Record<MultaDoCredenciado['status_multa'], StatusVariant> = {
  APLICADA: 'bloqueado',
  RECORRIDA: 'pendente',
  CANCELADA: 'cancelado',
};

/**
 * Aba "Multas". SEM CLIQUE NA LINHA DE PROPOSITO: o protótipo levava a
 * `/multas/:id`, rota que nao existe aqui — ver o mesmo raciocinio em `AbaTermos`.
 */
export function AbaMultas({ credenciadoId }: AbaMultasProps) {
  const { data: multas, isLoading } = useMultasDoCredenciado(credenciadoId);

  return (
    <Card>
      <CardContent className="p-6">
        {isLoading ? (
          <Spinner size="sm" />
        ) : !multas || multas.length === 0 ? (
          <EmptyState
            icon={Gavel}
            title="Nenhuma multa"
            description="Multas aplicadas serão exibidas aqui."
          />
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Infração</TableHead>
                <TableHead>Mês ref.</TableHead>
                <TableHead>Percentual</TableHead>
                <TableHead>Status</TableHead>
                <TableHead className="text-right">Valor</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {multas.map((multa) => (
                <TableRow key={multa.id}>
                  <TableCell>{humanizeLabel(multa.tipo_infracao)}</TableCell>
                  <TableCell>{multa.mes_referencia}</TableCell>
                  <TableCell>{multa.percentual}%</TableCell>
                  <TableCell>
                    <StatusBadge
                      status={SELO_DA_MULTA[multa.status_multa]}
                      label={multa.status_multa}
                    />
                  </TableCell>
                  <TableCell className="text-right font-mono">
                    {formatarDinheiro(multa.valor_multa)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
